<google-map
    [options]="options"
    (mapClick)="mapClick($event)"
    class="map"
    [width]="width"
    [height]="height"
  >
    <map-marker
      *ngFor="let marker of markerPosition"
      [position]="marker"
      [options]="{ icon: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'}"
      (mapClick)="mapClick($event)"
    ></map-marker>

    <map-marker 
      *ngIf="selectedLocation"
      [position]="selectedLocationLatLng"
      [options]="{ icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'}"
    >
      <map-circle
        [center]="selectedLocationLatLng"
        [options]="circleOptions"
        (circleClick)="circleClick($event)"
      ></map-circle>
    </map-marker>

    <map-marker
      *ngIf="chargingLocation"
      [position]="{lat: chargingLocation.latitude, lng: chargingLocation.longitude}"
      [options]="{ icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'}"
    >
      <map-circle 
        [center]="{lat: chargingLocation.latitude, lng: chargingLocation.longitude}"
        [options]="circleOptions"
      ></map-circle>
    </map-marker>
</google-map>